import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersArchivedJobCategoryPhasesIndexResponseType } from "~/domains";

type RequestDataType = {
  page?: number;
};

const request = async ({
  page = 1,
}: RequestDataType): Promise<ApiManagersArchivedJobCategoryPhasesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersArchivedJobCategoryPhasesIndexResponseType>(
      "/api/managers/archived_job_category_phases",
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersArchivedJobCategoryPhasesIndex = ({
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersArchivedJobCategoryPhasesIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersArchivedJobCategoryPhasesIndex"],
    ({ pageParam }) => {
      return request({ page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
